import { IpaType } from "../phonemes/ipa";

/** describes when & how to change a string */
export interface Change {
  readonly input: And;
  readonly output: IpaType[];
  readonly pre?: Condition;
  readonly post?: Condition;
}

/** item needs to match everything in the list */
export type And = (IpaType | Or | Not)[];

/** item needs to match one of the items in the list */
export interface Or {
  readonly or: (IpaType | Not | Boundary)[];
}
export function isOr(item: unknown): item is Or {
  return (item as Or).or !== undefined;
}

/** a condition must not match */
export interface Not {
  readonly not: IpaType | Or;
}
export function isNot(item: unknown): item is Not {
  return (item as Not).not !== undefined;
}

/** a condition that has to be matched */
export type Condition = Boundary | And;

/** word boundary */
export type Boundary = '#boundary';
